module.exports = __webpack_public_path__ + "img/playbutton12.f610ff4a.png";